module.exports = __webpack_public_path__ + "static/media/next.3376afde.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/next.png
// module id = 167
// module chunks = 0